import { useMemo } from 'react';
import { useNodes, useEdges } from '@xyflow/react';
import { VariableType } from '@/proto/common';
import { getAncestorVariables } from '@/pages/Logiblocks/variables/variableUtils';
import type { ReactFlowEdge, ReactFlowNode } from '@/pages/Logiblocks/types';

/**
 * Whether an ancestor of `nodeId` publishes an alert (e.g. the alert trigger),
 * meaning the workflow can run on an alert when it reaches this node.
 */
export function useHasUpstreamAlert(nodeId: string): boolean {
  const nodes = useNodes<ReactFlowNode>();
  const edges = useEdges<ReactFlowEdge>();

  return useMemo(
    () =>
      getAncestorVariables(nodeId, nodes, edges).some((ancestor) =>
        ancestor.filteredOutputVariables.some(
          (output) => output.variable!.type === VariableType.ALERT
        )
      ),
    [nodeId, nodes, edges]
  );
}
